// components/misc/Workflow/TriggerNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const TriggerResponseNode = React.forwardRef(({ data, isConnectable }, ref) => {
    const handleStyle = {
        backgroundColor: "black",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        border: "1px solid #ccc", // Added border for better visibility
        // boxShadow: "0 0 2px rgba(0,0,0,0.2)", // Added box shadow for better visibility
        cursor: "pointer", // Added cursor style
    };

    const handleClick = (event) => {
        if (data.onClick) {
            data.onClick(event, data.id);
        }
    }
    

    return (
        <div onClick={handleClick} ref={ref} className="relative w-[140px] rounded-md border border-gray-800 bg-white p-1 text-center text-gray-900">
            <Handle
                type="target"
                position={Position.Top} // Changed to bottom
                id="a"
                isConnectable={isConnectable}
                style={handleStyle}
            />
            <div title={data.label} className="overflow-hidden text-ellipsis whitespace-nowrap text-[0.5rem]">{data.label}</div>
        </div>
    );
});

export default TriggerResponseNode;
